import './styles.scss';

import {
    Plugins,
    Capacitor,
    Device,
    SplashScreen,
    App
} from '@capacitor/core';

import { FCM } from "@capacitor-community/fcm";

const { PushNotifications } = Plugins;

const SideMenu = () => import('./components/side-menu/index.vue');
const SearchModal = () => import('./components/search-modal/index.vue');

export default {
    name: 'app',

    components: {
        'side-menu': SideMenu,
    },

    data() {
        return {
            main_pages: [
                {
                    title: 'Home',
                    slug: 'action'
                },
                {
                    title: 'Annotations',
                    slug: 'annotations'
                },
                {
                    title: 'Account',
                    slug: 'account'
                }
            ],

            active_tab: '',

            animation_name: 'next',

            fcm: new FCM(),
            fcmToken: false,
            update_poll: false
        }
    },

    computed: {
        desktop() {
            return this.$store.state.desktop;
        },

        disableMenu() {
            let windowSize = !this.desktop ? true : false;   
            return windowSize;
        },

        hideMenu() {
            if (!this.disableMenu) {
                return !this.$store.state.activeMenu;
            } else {
                return this.disableMenu;
            }
        },

        online() {
            return this.$store.state.online_status;
        },

        subscription() {
            return this.$store.getters.getActiveSubscription;
        },
        
        canSearch() { 
            if (this.subscription && this.subscription.permissions) {
                return this.subscription.permissions.includes('search');
            }
            return false;
        }
    },

    watch: {
        $route(to, from) {
            this.animation_name = this.$store.state.animation;
            this.$store.commit('setAnimation', 'next');

            let name = to.meta.tab;
            this.makeActive(name);
            
            this.$store.commit('setPreviousPage', from);
        },

        online(newStatus, oldStatus) {
            // device internet connection established, update content
            if (oldStatus === false && newStatus === true) {
                this.$store.dispatch('updateData');
                this.new_connection = true;
            }
        }
    },

    created() {
        this.$store.dispatch('getUserQuota');
        this.$store.dispatch('getSubscription');
        
        this.$store.dispatch('checkAuthorization').then(() => {
            if (window.location.pathname === '/') {
                this.$router.push({ path: '/action' });
            }
        }).catch(() => {
            this.$router.push({ path: '/' });
        });

        window.addEventListener('resize', this.resize);

        this.resize();

        window.addEventListener('online',  this.onlineStatusUpdated);
        window.addEventListener('offline', this.onlineStatusUpdated);

        this.onlineStatusUpdated();
        this.setupNotifications();

    },

    mounted() {
        window.addEventListener('orientationchange', this.resize.bind());
        App.addListener('appStateChange', this.appResume);
        this.update_poll = setTimeout(()=> { this.updateData(); }, 300000);
        this.$store.dispatch('getUserQuota');
        this.$store.dispatch('getSubscription');
        this.$store.dispatch('checkOnlineStatus');
        this.resize();
        SplashScreen.hide();
    },

    beforeDestroy() {
        clearInterval(this.update_poll);
    },

    methods: {

        appResume({ isActive }) {
            if (isActive) {
                console.info('App is active');
                this.$store.dispatch('updateData');
            }
        },

        resize() {
            const height = window.innerHeight, width = window.innerWidth;
            this.$store.commit('setDesktop', width >= 768);
            this.$store.commit('setHeight', height);
            this.$store.commit('setWidth', width);
        },

        onlineStatusUpdated() {
            this.$store.dispatch('checkOnlineStatus');
        },

        checkActive(slug) {
            if (this.active_tab === slug) {
                return true;
            } else {
                return false;
            }
        },

        makeActive(slug = '') {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.active_tab = slug;
                }, 50);
            });
        },

        updateData() {
            const active = this.$store.getters.getActiveSubscription;
            if (active) {
                this.$store.dispatch('updateData');
            }
        },

        handleNotification(data) {
            console.info(data);
        },

        setupNotifications() {
            try {
                PushNotifications.requestPermission().then(result => {
                    if (result.granted) {
                        PushNotifications.register();
                    }
                });
                PushNotifications.addListener('registration', (data) => {
                    this.fcm.getToken().then((result) =>{
                        this.fcmToken = result.token;
                        this.$store.commit('setFCMToken', this.fcmToken);
                    }).catch((err) => console.log(err));
                });
                PushNotifications.addListener('pushNotificationReceived', this.handleNotification.bind() );
            } catch (e) {
                // 
            }
        },

        search() {
            this.$ionic.modalController.create({
                component: SearchModal
            }).then(m => m.present());
        }
    }
}